import {action, makeAutoObservable} from "mobx";
import CommonStore from "../../../stores/CommonStore";
import CustomCategoryWeightRangeSalePrice from "../../../model/packageDelivery/customCategory/CustomCategoryWeightRangeSalePrice";
import { SalePriceService } from "../../../service/SalePriceService";


class RemovePackageCustomCategoryWeightRangeSalePriceStore {

    public salePriceId: string;
    public salePriceCustomCategoryWeightRange: CustomCategoryWeightRangeSalePrice;
    public loading: boolean;
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore, salePriceId: string, salePriceCustomCategoryWeightRange: CustomCategoryWeightRangeSalePrice) {
        this.salePriceId = salePriceId;
        this.salePriceCustomCategoryWeightRange = salePriceCustomCategoryWeightRange;
        this.loading = false;
        this.commonStore = commonStore;
        makeAutoObservable(this);
    }


    @action
    public async remove() {
        const response = await SalePriceService.removeCustomCategoryWeightRangeItemSalePrice(this.salePriceId, this.salePriceCustomCategoryWeightRange.id);
        this.commonStore.processErrors(response);
        return response.success;
    }
}

export default RemovePackageCustomCategoryWeightRangeSalePriceStore;

